import React from 'react'
import PropTypes from 'prop-types'
import './styles.scss'

const Button = (props) => {
  const bg = props.backgroundColor ? `bg-${props.backgroundColor}` : 'bg-main'
  const size = props.size ? 'btn-' + props.size : ''
  const color = props.color ? 'btn-color' : ''

  const fontSize = props.fontSize ? 'btn-' + props.fontSize : ''

  const borderRadius = props.borderRadius ? 'btn-border-' + props.borderRadius : ''

  return (
    <button
      className={`btn ${bg} ${size} ${color} ${fontSize} ${borderRadius}`}
      onClick={props.onClick ? () => props.onClick() : null}
    >
      <span className="btn__txt">{props.children}</span>
      {props.icon ? (
        <span className="btn__icon">
          <i className={`${props.icon} bx-tada`}></i>
        </span>
      ) : null}
    </button>
  )
}

Button.propTypes = {
  fontSize: PropTypes.string,
  borderRadius: PropTypes.string,
  backgroundColor: PropTypes.string,
  size: PropTypes.string,
  icon: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func
}

export default Button
